/**
 * Single accessor for the bi-api bearer token.
 *
 * Angular provides it via `window.LOOKER_CONFIG.authToken`. When the access
 * token expires, `baseApi` refreshes it against `studio-api` using the
 * refresh token from `window.LOOKER_CONFIG.refreshToken` (or `useAuthStore`
 * once the store has been updated with a fresher pair).
 *
 * No other token accessor should exist. The Looker service token must NEVER
 * be reachable from client code — all Looker traffic goes through the backend
 * `/v7/looker/*` proxy.
 */
import { useAuthStore } from '../stores';

export function getBackendToken(): string | null {
  const storeToken = useAuthStore.getState().accessToken;
  if (storeToken) return storeToken;

  const winToken = typeof window !== 'undefined' ? window.LOOKER_CONFIG?.authToken : undefined;
  return winToken || null;
}

export function getRefreshToken(): string | null {
  const storeToken = useAuthStore.getState().refreshToken;
  if (storeToken) return storeToken;

  const winToken = typeof window !== 'undefined' ? window.LOOKER_CONFIG?.refreshToken : undefined;
  return winToken || null;
}
